export const RoutePath = {
    // Main routes
    Home: '/',
    Onboarding: '/onboarding',
    // Authentication routes
    Login: '/login',
    Signup: '/signup',
    ForgotPassword: '/forgot-password',
    ResetPassword: '/reset-password',
    AcceptInvitation: '/accept-invitation',
    VerifyEmail: '/verify-email',
    // Account settings routes
    AccountSettings: '/account-settings',
    AccountSettingsProfile: '/account-settings/profile',
    AccountSettingsGeneral: '/account-settings/general',
    AccountSettingsBilling: '/account-settings/billing',
    AccountSettingsIntegrations: '/account-settings/integrations',
    AccountSettingsChannels: '/account-settings/channels',
    AccountSettingsBrands: '/account-settings/brands',
    AccountSettingsUsers: '/account-settings/users',
    AccountSettingsTeams: '/account-settings/teams',
    // Web pages routes
    WebPages: '/web-pages',
    Microsites: '/web-pages/microsites',
    Menus: '/web-pages/menus',
    Forms: '/web-pages/forms',
    DigitalLegacy: '/digital',
    MicrositesLegacy: '/microsites',
    MenusLegacy: '/menus',
    // Contacts routes
    Contacts: '/contacts',
    // Social routes
    Social: '/social',
    SocialPosts: '/social/posts',
    SocialAnalytics: '/social/analytics',
    // Reviews routes
    Reviews: '/reviews',
    ReviewsManage: '/reviews/manage',
    ReviewsAnalytics: '/reviews/analytics',
    ReviewsAnalyticsReviews: '/reviews/analytics/reviews',
    ReviewsAnalyticsKeywords: '/reviews/analytics/keywords',
    ReviewsAnalyticsOperationalInsights: '/reviews/analytics/operational-insights',
    ReviewsAutomation: '/reviews/automation',
    ReviewsAutomationTemplates: '/reviews/automation/templates',
    ReviewsAutomationAutoReplies: '/reviews/automation/auto-replies',
    ReviewsWidgets: '/reviews/widgets',
    // Surveys routes
    Surveys: '/surveys',
    SurveysResponses: '/surveys/responses',
    SurveysResponsePhoto: '/surveys/responses/photos/:photoId',
    SurveysTemplates: '/surveys/templates',
    SurveysAnalytics: '/surveys/analytics',
    SurveysAnalyticsConversion: '/surveys/analytics/conversion',
    SurveysAnalyticsResponses: '/surveys/analytics/responses',
    SurveysAnalyticsSurveyInsights: '/surveys/analytics/survey-insights',
    // Messaging routes
    Messaging: '/messaging',
    MessagingInbox: '/messaging/inbox',
    MessagingPulseAI: '/messaging/pulse-ai',
    MessagingPulseAIAgents: '/messaging/pulse-ai/agents',
    MessagingPulseAIKnowledgeBase: '/messaging/pulse-ai/knowledge-base',
    MessagingAnalytics: '/messaging/analytics',
    // Campaigns routes
    Campaigns: '/campaigns',
    CampaignsOneTime: '/campaigns/one-time',
    CampaignsAutomated: '/campaigns/automated',
    CampaignsLibrary: '/campaigns/library',
    // Locations routes
    Locations: '/locations',
    LocationsManage: '/locations/manage',
    LocationsProfiles: '/locations/profiles',
    LocationsMedia: '/locations/media',
    LocationsVisibilityScanner: '/locations/visibility-scanner',
    LocationsAnalytics: '/locations/analytics',
    LocationsAnalyticsPerformance: '/locations/analytics/performance',
    // Visibility moved out of the analytics tabs (kept for redirects)
    LocationsAnalyticsVisibilityLegacy: '/locations/analytics/visibility',
    // Presence routes (kept for redirects)
    Presence: '/presence',
    PresenceProfiles: '/presence/profiles',
    PresenceMedia: '/presence/media',
    PresenceAnalytics: '/presence/analytics',
    // Coupons routes
    Coupons: '/coupons',
    // Error routes
    Error: '/error',
    // Catch-all route
    NotFound: '*',
};

const helpCenterUrl = (localePrefix, path = '') => `https://www.pluspoint.io${localePrefix}/help${path}`;

const learnMore = {
    GB: {
        google: helpCenterUrl('', '/integrations/google-business-profile'),
        brand: helpCenterUrl('', '/settings/managing-brands'),
        channels: helpCenterUrl('', '/channels'),
        templates: helpCenterUrl('', '/surveys/creating-survey-templates'),
        autoReplies: helpCenterUrl('', '/reviews/auto-replies'),
        users: helpCenterUrl('', '/settings/managing-users'),
        linkTracking: helpCenterUrl('', '/settings/account-settings#tag-listing-links-for-analytics'),
        mcp: helpCenterUrl('', '/settings/connecting-ai-assistants'),
        emailReplies: helpCenterUrl('', '/channels/email-on-your-domain'),
        liveChatWebsite: helpCenterUrl('', '/integrations/live-chat-on-your-website'),
    },
    ES: {
        google: helpCenterUrl('/es', '/integrations/google-business-profile'),
        brand: helpCenterUrl('/es', '/settings/managing-brands'),
        channels: helpCenterUrl('/es', '/channels'),
        templates: helpCenterUrl('/es', '/surveys/creating-survey-templates'),
        autoReplies: helpCenterUrl('/es', '/reviews/auto-replies'),
        users: helpCenterUrl('/es', '/settings/managing-users'),
        linkTracking: helpCenterUrl(
            '/es',
            '/settings/account-settings#etiquetar-los-enlaces-de-las-fichas-para-la-analítica',
        ),
        mcp: helpCenterUrl('/es', '/settings/connecting-ai-assistants'),
        emailReplies: helpCenterUrl('/es', '/channels/email-on-your-domain'),
        liveChatWebsite: helpCenterUrl('/es', '/integrations/live-chat-on-your-website'),
    },
    PT: {
        google: helpCenterUrl('/pt', '/integrations/google-business-profile'),
        brand: helpCenterUrl('/pt', '/settings/managing-brands'),
        channels: helpCenterUrl('/pt', '/channels'),
        templates: helpCenterUrl('/pt', '/surveys/creating-survey-templates'),
        autoReplies: helpCenterUrl('/pt', '/reviews/auto-replies'),
        users: helpCenterUrl('/pt', '/settings/managing-users'),
        linkTracking: helpCenterUrl('/pt', '/settings/account-settings#marcar-os-links-das-fichas-para-a-análise'),
        mcp: helpCenterUrl('/pt', '/settings/connecting-ai-assistants'),
        emailReplies: helpCenterUrl('/pt', '/channels/email-on-your-domain'),
        liveChatWebsite: helpCenterUrl('/pt', '/integrations/live-chat-on-your-website'),
    },
    UA: {
        google: 'https://pluspoint.notion.site/ced4e92ce93846ad923ca0a569af97d8',
        brand: 'https://pluspoint.notion.site/00997ec57ff94ac5a63c764722bb56b9',
        channels: 'https://pluspoint.notion.site/0c22e9b9906a4339a784f782dbaf8f02',
        templates: 'https://pluspoint.notion.site/57b1016542994ba1924b6d934485f27e',
        autoReplies: 'https://pluspoint.notion.site/ed4e191fe10b4dee89bd7df0c242daec',
        users: 'https://pluspoint.notion.site/27e6c01e7cbf4fa790979ccecd20f003',
        linkTracking: helpCenterUrl('', '/settings/account-settings#tag-listing-links-for-analytics'),
        mcp: helpCenterUrl('', '/settings/connecting-ai-assistants'),
        emailReplies: helpCenterUrl('', '/channels/email-on-your-domain'),
        liveChatWebsite: helpCenterUrl('', '/integrations/live-chat-on-your-website'),
    },
};

export const ExternalRoutes = {
    // Google Services
    GoogleBusinessLocations: 'https://business.google.com/locations',
    GoogleBusinessGroups: accountId => `https://business.google.com/groups/${accountId}/locations`,
    // Pluspoint Services
    ReferralProgram: 'https://referral.pluspoint.io/',
    SupportForm: 'https://share.hsforms.com/1VAYqLOrmS7K3bD-dCdxdoA5jjzz',
    // Help Center
    HelpCenter: {
        GB: helpCenterUrl(''),
        ES: helpCenterUrl('/es'),
        PT: helpCenterUrl('/pt'),
        UA: 'https://pluspoint.notion.site/Help-Center-UK-e685fa7caca14eeaa268982eb3d4d172',
    },
    ApiIntegrationDocs: 'https://docs.pluspoint.io',
    // Learn More Links
    LearnMore: learnMore,
    // Integration Learn More Links
    IntegrationLearnMore: {
        GB: learnMore.GB.google,
        ES: learnMore.ES.google,
        PT: learnMore.PT.google,
        UA: learnMore.UA.google,
    },
    VTEXInstructions: {
        GB: helpCenterUrl('', '/integrations/vtex'),
        ES: helpCenterUrl('/es', '/integrations/vtex'),
        PT: helpCenterUrl('/pt', '/integrations/vtex'),
        UA: helpCenterUrl('', '/integrations/vtex'),
    },
    IntegrationsPage: {
        GB: 'https://www.pluspoint.io/integrations',
        ES: 'https://www.pluspoint.io/es/integrations',
        PT: 'https://www.pluspoint.io/pt/integrations',
        BR: 'https://www.pluspoint.io/pt/integrations',
    },
    TermsLink: 'https://www.pluspoint.io/legal/terms',
    PrivacyLink: 'https://www.pluspoint.io/legal/privacy',
    DPALink: 'https://www.pluspoint.io/legal/dpa',
};
